import { isAnyOf } from '@reduxjs/toolkit';

import { getSignalRConnector } from '@/api/signalR/SignalRConnector.ts';
import { userApi } from '@/api/user/index.ts';
import { blotterApi } from '@/store/blotter/api/index.ts';
import { blotterSlice } from '@/store/blotter/slice.ts';
import type { StartAppListening } from '@/store/listenerMiddleware.ts';
import { store } from '@/store/store.ts';
import { streamingSlice } from '@/store/streaming/slice.ts';
import { userPreferencesSlice } from '@/store/userPreferences/slice.ts';

const {
  endpoints: { register },
} = blotterApi;
const {
  endpoints: { currentUser, updateUserPreferences },
} = userApi;
const {
  selectors: { getUserPreferences },
} = userPreferencesSlice;
const {
  actions: { signalRStatusUpdated },
  selectors: { getSignalRConnectionId },
} = streamingSlice;

const signalRConnector = getSignalRConnector();
signalRConnector.on('ReceiveTradeNotification', (notifications) => {
  store.dispatch(blotterSlice.actions.liveTradeReceived(notifications));
});
signalRConnector.on('ReceiveOrderNotification', (notifications) => {
  store.dispatch(blotterSlice.actions.liveOrderReceived(notifications));
});

export const registerBlotterRegistrationListeners = (startAppListening: StartAppListening) => {
  // telling the webapi what  range of blotter data we want to receive
  // this will be done whenever the user pref 'showMyMainDeals' changes, or when we just connected to signalR
  startAppListening({
    matcher: isAnyOf(currentUser.matchFulfilled, updateUserPreferences.matchFulfilled, signalRStatusUpdated),
    effect: async (_action, { dispatch, getState, getOriginalState }) => {
      const previousState = getOriginalState();
      const state = getState();

      const { showMyMainDeals: previousShowMyMainDeals } = getUserPreferences(previousState);
      const { showMyMainDeals } = getUserPreferences(state);

      const previousDataStreamId = getSignalRConnectionId(previousState);
      const dataStreamId = getSignalRConnectionId(state);

      if (!dataStreamId) {
        return;
      }

      const justGotConnected = !previousDataStreamId && !!dataStreamId;
      const showMyMainDealsChanged = previousShowMyMainDeals !== showMyMainDeals;

      if (justGotConnected || showMyMainDealsChanged) {
        dispatch(register.initiate({ dataStreamId, showMyMainDeals }));
      }
    },
  });
};
